import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import './index.scss';

export default function Input(props) {
    const properties = R.pipe(R.assoc('className', classNames(props.className, 'input')))(props);
    return <input type="text" {...properties} />;
}



// WEBPACK FOOTER //
// ./components/input/index.js